export const withHKDollarSign = (value: string | number) => {
  const hkDollarSign = `HK$`;

  if (!value || value === '0') return `${hkDollarSign} 0.00`;

  return `HK$ ${value}`;
};
